import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { flowRight } from 'lodash';
import EmptyStates from '../../components/empty-states';
import withTranslate from '../../hoc/with-translate';
import styles from './restriction-private-member.scss';
import Button from '../button';
import { showJoinCommunityPopup } from '../../services/join-community-popup-service';

const RestrictionPrivateMember = ({ t }) =>
  <EmptyStates
    className={classNames(styles.emptyStates, 'restriction')}
    title={t('restriction-private-member.title')}
    content={t('restriction-private-member.content')}
  >
    <Button className={classNames('login-button')} onClick={showJoinCommunityPopup}>
      {t('restriction-private-member.button')}
    </Button>
  </EmptyStates>;

RestrictionPrivateMember.propTypes = {
  t: PropTypes.func,
};

export default flowRight(
  withTranslate
)(RestrictionPrivateMember);



// WEBPACK FOOTER //
// ./app/components/restriction-private-member/restriction-private-member.js